import {Event} from "../Event";

export enum DiagramEditorEventType {
    MODAL_WINDOW_VISIBILITY_CHANGED = "MODAL_WINDOW_VISIBILITY_CHANGED",
}

export interface ModalWindowVisibilityChangedEvent extends Event {
    type: DiagramEditorEventType.MODAL_WINDOW_VISIBILITY_CHANGED;
    isVisible: boolean;
}